<template>
  <b-card>
    <b-card-header>
      <h2>About Us</h2>
    </b-card-header>
    <b-card-body>
      <p style="text-align: left;">
        Shades of Polaris, LLC is an entertainment company that seeks to help enrich the enjoyment and satisfaction of gamers everywhere. <br /> Founded and run by Neville Kelly.
      </p>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  name: 'AboutView',
  data () {
    return {
      msg: 'About Us'
    }
  }
}
</script>
